import { buildMeta } from "../../routeMeta";

export { default } from "../../../src/pages/data";

export function meta(args) {
  return buildMeta(
    {
      title: "Data Downloads — The Atlas of Economic Complexity",
      description:
        "Download Atlas trade and economic-complexity datasets used by the Harvard Growth Lab.",
    },
    args,
  );
}
